import global from '../general/global';

export default {
    initializeSwiper: function () {
        let titleWithImageSwiper;

        if (!global.swiperLoaded) {
            loadjs([menaObject.assets + '/js/swiper.min.js', menaObject.assets + '/css/swiper.css'], function () {
                titleWithImageSwiper = new Swiper('.js-text-with-image--swiper', {
                    slidesPerView: 1,
                    navigation: {
                        nextEl: '.js-text-with-image--swiper-next',
                        prevEl: '.js-text-with-image--swiper-prev',
                    },
                });

                global.swiperLoaded = true;
            });
        } else {
            titleWithImageSwiper = new Swiper('.js-text-with-image--swiper', {
                slidesPerView: 1,
                navigation: {
                    nextEl: '.js-text-with-image--swiper-next',
                    prevEl: '.js-text-with-image--swiper-prev',
                },
            });
        }
    },
};
